import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AdmihairBaseComponent } from "../../../admihair-base.component";
import { UtilStorageService } from "src/app/admihair/service/util-storage.service";
import { ErroService } from "src/app/admihair/service/erro.service";
import { Table } from "primeng/table";
import { AuthUtil } from "src/app/admihair/util/auth-util";
import { FolhaPessoaFisicaService } from "src/app/admihair/service/folha-pessoa-fisica.service";
import { Contrato } from "src/app/admihair/api/dto/contrato";
import { Profissional } from "src/app/admihair/api/dto/profissional";
import { ContratoService } from "src/app/admihair/service/contrato.service";
import { ProfissionalService } from "src/app/admihair/service/profissional.service";
import { forkJoin, tap } from "rxjs";
import { ConfirmationService, SelectItem } from "primeng/api";
import { ItemLancamentoFolha } from "src/app/admihair/api/dto/item-lancamento-folha";
import { FolhaPessoaFisica } from "src/app/admihair/api/dto/folha-pessoa-fisica";
import { ContratoFolha, FolhaAgrupada } from "src/app/admihair/api/dto/folha-agrupada";

interface expandedRows {
    [key: string]: boolean;
}

interface PlanoContaBasico {
    codigo: number;
    descricao: string;
    codigoComissao?: number;
    aplicacao?: string;
}

@Component({
    selector: "app-lancamento-folha-listar",
    templateUrl: "./lancamento-folha-listar.component.html",
    styleUrls: ["./lancamento-folha-listar.component.scss"],
})
export class LancamentoFolhaListarComponent extends AdmihairBaseComponent implements OnInit {

    @ViewChild("filter") filter!: ElementRef;
    loading: boolean = false;
    filtroCompetencia: Date = new Date();
    listaContratosFolha: ContratoFolha[] = [];

    listaContratos: SelectItem[] = [
        { label: 'TODOS', value: undefined }
    ];
    contratoSelecionado?: Contrato;

    listaProfissionais: SelectItem[] = [
        { label: 'TODOS', value: undefined }
    ];
    profissionalSelecionado?: Profissional;

    expandedRows: expandedRows = {};
    isExpanded: boolean = false;

    progressoRequisicaoSalvarDialog: boolean = false;
    exibirDialog: boolean = false;
    loadingDialog: boolean = false;
    loadingTableDialog: boolean = false;
    filtroCompetenciaDialog: Date = new Date();


    listaPlanoConta: SelectItem[] = [
        { label: '13º Salário', value: { codigo: 32, descricao: '13º SALÁRIO', aplicacao: 'COLABORADOR' } },
        { label: 'Auxílio Transporte', value: { codigo: 50, descricao: 'AUXÍLIO TRANSPORTE', aplicacao: 'AMBOS' } },
        { label: 'Comissões de Produtos', value: { codigo: 25, descricao: 'COMISSÕES DE PRODUTOS', codigoComissao: 3, aplicacao: 'AMBOS' } },
        { label: 'Comissões de Serviços', value: { codigo: 25, descricao: 'COMISSÕES DE SERVIÇOS', codigoComissao: 4, aplicacao: 'AMBOS' } },
        { label: 'Gratificações', value: { codigo: 28, descricao: 'GRATIFICAÇÕES', aplicacao: 'AMBOS' } },
        { label: 'Mei Parceiros', value: { codigo: 60, descricao: 'MEI PARCEIROS', aplicacao: 'PARCEIRO' } },
        { label: 'Pagamento de Metas', value: { codigo: 27, descricao: 'PAGAMENTO DE METAS', aplicacao: 'AMBOS' } },
        { label: 'Salários', value: { codigo: 24, descricao: 'SALÁRIOS', aplicacao: 'COLABORADOR' } }
    ];
    planoContaSelecionado?: PlanoContaBasico;

    listaLancamentosFolha: ItemLancamentoFolha[] = [];
    listaLancamentosFolhaSelecionados: ItemLancamentoFolha[] = [];

    competenciaFormatada?: string; 
    exibirFolhaFinalizada: boolean = false;
    folhaProcessada: boolean = true;

    constructor(private contratoService: ContratoService,
        private confirmationService: ConfirmationService,
        private profissionalService: ProfissionalService,
        private folhaPfService: FolhaPessoaFisicaService,
        erroService: ErroService,
        utilStorageService: UtilStorageService
    ) {
        super(erroService, utilStorageService);
    }

    ngOnInit(): void {
        this.verificarPermissoes();
        if (this.permissaoListar) {
            this.loading = true;
            this.carregarFiltros();
        }
    }

    carregarFiltros() {
        const empresaId = this.getEmpresa().id;
        forkJoin([
            this.contratoService.listarPorEmpresaId(empresaId),
            this.profissionalService.listarPorEmpresaId(empresaId)
        ]).subscribe({
            next: ([contratosResponse, profissionaisResponse]) => {

                contratosResponse.map(c =>
                    this.listaContratos.push({ label: c.razaoSocial, value: c }));

                profissionaisResponse.map(p =>
                    this.listaProfissionais.push({ label: p.nomeProfissional, value: p }));

                this.listarDados();
            },
            error: (err: any) => {
                this.loading = false;
                this.exibirMensagemErro(err);
            }
        })
    }

    listarDados() {
        this.folhaPfService.listarExtratoPorEmpresa(
            this.getEmpresa().id,
            this.filtroCompetencia,
            this.contratoSelecionado?.id,
            this.profissionalSelecionado?.id
        ).subscribe({
            next: (response: FolhaAgrupada) => {
                this.listaContratosFolha = response.data;
                this.folhaProcessada = response.folhaProcessada;
                this.loading = false;
                console.log(response)
            },
            error: (err: any) => {
                this.loading = false;
                this.exibirMensagemErro(err);
            },
        });
    }

    filtrar() {
        this.loading = true;
        this.listarDados();
    }

    expandAll() {
        if (!this.isExpanded) {
            this.listaContratosFolha.forEach((contrato) =>
                contrato && contrato.razaoSocial
                    ? (this.expandedRows[contrato.razaoSocial] = true)
                    : ""
            );
        } else {
            this.expandedRows = {};
        }
        this.isExpanded = !this.isExpanded;
    }

    buscar(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, "contains");
    }

    limpar(table: Table) {
        table.clear();
        this.filter.nativeElement.value = "";
        this.filtroCompetencia = new Date();
        this.contratoSelecionado = undefined;
        this.profissionalSelecionado = undefined;
        this.loading = true;
        this.listarDados();
    }

    excluirItemFolha(id: number) {
        this.confirmationService.confirm({
            message: 'Tem certeza que seja excluir?',
            header: 'Confirmação',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.folhaPfService.excluir(id).subscribe({
                    next: () => {
                        this.exibirMensagemSucesso();
                        this.loading = true;
                        this.listarDados();
                    },
                    error: (err: any) => {
                        this.exibirMensagemErro(err);
                    }
                });
            }
        })

    }

    finalizarFolha() {
        this.competenciaFormatada = this.filtroCompetencia
        .toLocaleDateString('pt-BR',{month: '2-digit', year: 'numeric'});
                
        this.confirmationService.confirm({
            message: `Deseja finalizar a folha na competência ${this.competenciaFormatada}?`,
            header: 'Finalizar Folha',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            acceptButtonStyleClass: 'shadow-none',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.folhaPfService.finalizarFolha(this.getEmpresa().id,this.filtroCompetencia)
                .subscribe({
                    next: () => {
                        this.exibirMensagemSucesso();
                        this.listarDados();
                    },
                    error: (err: any) => {
                        this.exibirFolhaFinalizada = false;
                        this.exibirMensagemErro(err);
                    }
                })
            }
        })
    }

    verificarPermissoes() {
        this.permissaoListar = AuthUtil.verificarPermissao("PERM_LANCAMENTO_FOLHA");
        this.permissaoExcluir = AuthUtil.verificarPermissao("PERM_EXCLUIR_LANCAMENTO_FOLHA");
    }

    abrirDialog() {
        this.reinicializarVariaveisDialog();
        this.exibirDialog = true;
    }

    reinicializarVariaveisDialog() {
        this.listaLancamentosFolha = [];
        this.listaLancamentosFolhaSelecionados = [];
        this.filtroCompetenciaDialog = new Date();
        this.planoContaSelecionado = undefined;
    }


    buscarDadosLancamentos() {
        if (this.filtroCompetenciaDialog && this.planoContaSelecionado) {
            this.loadingTableDialog = true;
            this.listaLancamentosFolha = [];
            this.listaLancamentosFolhaSelecionados = [];

            this.folhaPfService.listarItemLancamentoFolha(
                this.getEmpresa().id,
                this.planoContaSelecionado?.codigo,
                this.planoContaSelecionado?.codigoComissao,
                this.planoContaSelecionado?.aplicacao,
                this.filtroCompetenciaDialog
            ).subscribe({
                next: (data: ItemLancamentoFolha[]) => {
                    this.listaLancamentosFolha = data;
                    this.loadingTableDialog = false;
                },
                error: (err: any) => {
                    this.loadingTableDialog = false;
                    this.exibirMensagemErro(err);
                }
            });
        }
    }

    salvarLancamentosFolha() {
        this.progressoRequisicaoSalvarDialog = true;
        let lancamentos: FolhaPessoaFisica[] = [];
        this.listaLancamentosFolhaSelecionados.forEach((item) => {
            const lancamento: FolhaPessoaFisica = {
                empresaId: this.getEmpresa().id,
                codigoPlanoConta: this.planoContaSelecionado?.codigo,
                contratoId: item.contratoId,
                saldoContrato: item.saldoContrato,
                profissionalId: item.profissionalId,
                dataCompetencia: this.filtroCompetenciaDialog,
                valorRegistro: item.valorRegistro,
                descricao: this.planoContaSelecionado?.descricao,
                parcela: 'PARCELA 1/1'
            };
            lancamentos.push(lancamento);
        });

        this.folhaPfService.salvarLista(lancamentos).subscribe({
            next: () => {
                this.exibirMensagemSucesso();
                this.progressoRequisicaoSalvarDialog = false;
                this.exibirDialog = false;
                this.listarDados();
            },
            error: (err: any) => {
                this.progressoRequisicaoSalvarDialog = false;
                this.exibirMensagemErro(err);
            }
        });

    }

}
